import React, { useState } from "react";
import styles from "./modal.module.css";
import Newtab from "../../assets/Newtab.svg";

export const Modalsuccessfile = ({
  loading,
  msg,
  txtmsg,
  Identifier,
  blockhash,
  fileHash,
  onClose,
  linkRegistry,
}) => {
  const [copied, setCopied] = useState();

  const copyToClipBoard = (data) => {
    navigator.clipboard.writeText(data);
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 3000);
  };

  return (
    <div
      className={`modal show fade modal-dialog-centered ${
        loading ? styles.disBlock : styles.disNone
      }`}
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className={`modal-content ${styles.successbody}`}>
          <div className="modal-body">
            <div className={styles.closesuccess} onClick={onClose}>
              X
            </div>
            <div className="w-1/2 h-1/2 rounded-lg overflow-hidden p-5">
              <div className="divsuccess">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <path
                      d="M20 7L9.00004 18L3.99994 13"
                      stroke="#000000"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>{" "}
                  </g>
                </svg>
              </div>
              <h4 className="mt-3 d-flex justify-content-center align-items-center">
                {msg}
              </h4>
              <p className="identip d-flex justify-content-center align-items-center">
                {txtmsg}
              </p>
               {/* Add File Hash Display */}
               {fileHash && (
                <p className="my-3">
                  Anchored this Digest: <span className="identip">{fileHash}</span>
                  <span
                    className="copy-identifier cursor-pointer"
                    onClick={() => copyToClipBoard(fileHash)}
                  >
                    <i className="fa-solid fa-copy"></i>
                    <span className="tipCopy">
                      {copied === "fileHash" ? "Copied" : "Copy"}
                    </span>
                  </span>
                </p>
              )}
              {Identifier ? (
                <p className="my-3">
                  Identifier :<span className="identip">{Identifier}</span>
                  <span
                    className="copy-identifier cursor-pointer"
                    onClick={() => copyToClipBoard(Identifier)}
                    id="copyId"
                  >
                    <i class="fa-solid fa-copy"></i>
                    <span className="tipCopy">
                      {copied ? "Copied" : "Copy"}
                    </span>
                  </span>
                </p>
              ) : null}
              {blockhash ? (
                <div className="mt-3 d-flex justify-content-center align-items-center">
                  <a
                    href={`https://apps.cord.network/?rpc=wss://weave3.testnet.dhiway.net/#/explorer/query/${blockhash}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linksuccess"
                  >
                    View in explorer
                  </a>
                  <img src={Newtab} height={15} width={15} alt="background" />
                </div>
              ) : null}
              {linkRegistry ? (
                <div className="mt-3 d-flex justify-content-center align-items-center">
                  <a
                    href={`${linkRegistry}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linksuccess"
                  >
                    View in Registry
                  </a>
                  <img src={Newtab} height={15} width={15} alt="background" />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
